import { XMarkIcon } from '@heroicons/react/24/solid'

import { cn } from '@/app/utils'

type Props = {
  variant?: 'default' | 'secondary'
  onClick: () => void
}

export const CloseButton = ({ onClick, variant = 'default' }: Props) => (
  <button
    aria-label="Закрыть"
    className={cn(
      'ml-auto flex h-40 w-40 rounded-100 p-8 outline-none transition-colors',
      'sm:p-4',
      variant === 'default'
        ? 'bg-grey-90  hover:bg-grey-100'
        : 'bg-grey-20 hover:bg-grey-10'
    )}
    onClick={onClick}
  >
    <XMarkIcon
      className={cn(
        'm-auto h-24 w-24',
        variant === 'default' ? 'text-grey-40' : 'text-bronze-40'
      )}
    />
  </button>
)
